import { render, staticRenderFns } from "./OnboardingWorkingHoursChoosePage.vue?vue&type=template&id=21d62507"
import script from "./OnboardingWorkingHoursChoosePage.vue?vue&type=script&lang=ts"
export * from "./OnboardingWorkingHoursChoosePage.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingWorkingHoursChoosePage.vue?vue&type=style&index=0&id=21d62507&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports